import * as React from 'react'

const SvgMovieIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 52 38" fill="none" {...props}>
    <path
      d="M44.448 0H7.208A7.198 7.198 0 000 7.208v22.825a7.198 7.198 0 007.208 7.207h37.24a7.198 7.198 0 007.208-7.208V7.208A7.198 7.198 0 0044.448 0zm2.883 30.032a2.892 2.892 0 01-2.883 2.884H7.208a2.892 2.892 0 01-2.883-2.883V7.207a2.892 2.892 0 012.883-2.883h37.24a2.892 2.892 0 012.883 2.883v22.825z"
      fill="url(#MovieIcon_svg__paint0_linear)"
    />
    <path
      d="M30.562 17.347l-7.016-4.085c-.48-.288-1.057-.288-1.49 0-.48.289-.768.77-.768 1.298v8.072c0 .53.288 1.01.768 1.298.24.144.48.192.77.192.24 0 .528-.048.768-.192l7.016-4.037c.48-.288.768-.768.768-1.297-.047-.528-.336-1.009-.816-1.25z"
      fill="url(#MovieIcon_svg__paint1_linear)"
    />
    <path
      d="M11.148 7.736H8.265a.964.964 0 00-.96.961v.961c0 .529.432.961.96.961h2.883a.964.964 0 00.961-.96v-.962a.964.964 0 00-.96-.96z"
      fill="url(#MovieIcon_svg__paint2_linear)"
    />
    <path
      d="M11.148 14.031H8.265a.964.964 0 00-.96.961v.961c0 .529.432.961.96.961h2.883a.964.964 0 00.961-.96v-.962a.964.964 0 00-.96-.96z"
      fill="url(#MovieIcon_svg__paint3_linear)"
    />
    <path
      d="M11.148 20.326H8.265a.964.964 0 00-.96.961v.961c0 .529.432.961.96.961h2.883a.964.964 0 00.961-.96v-.962a.964.964 0 00-.96-.96z"
      fill="url(#MovieIcon_svg__paint4_linear)"
    />
    <path
      d="M11.148 26.62H8.265a.964.964 0 00-.96.962v.96c0 .53.432.962.96.962h2.883a.964.964 0 00.961-.961v-.961a.964.964 0 00-.96-.961z"
      fill="url(#MovieIcon_svg__paint5_linear)"
    />
    <path
      d="M43.535 7.736h-2.883a.964.964 0 00-.961.961v.961c0 .529.432.961.961.961h2.883a.964.964 0 00.961-.96v-.962a.964.964 0 00-.96-.96z"
      fill="url(#MovieIcon_svg__paint6_linear)"
    />
    <path
      d="M43.535 14.031h-2.883a.964.964 0 00-.961.961v.961c0 .529.432.961.961.961h2.883a.964.964 0 00.961-.96v-.962a.964.964 0 00-.96-.96z"
      fill="url(#MovieIcon_svg__paint7_linear)"
    />
    <path
      d="M43.535 20.326h-2.883a.964.964 0 00-.961.961v.961c0 .529.432.961.961.961h2.883a.964.964 0 00.961-.96v-.962a.964.964 0 00-.96-.96z"
      fill="url(#MovieIcon_svg__paint8_linear)"
    />
    <path
      d="M43.535 26.62h-2.883a.964.964 0 00-.961.962v.96c0 .53.432.962.961.962h2.883a.964.964 0 00.961-.961v-.961a.964.964 0 00-.96-.961z"
      fill="url(#MovieIcon_svg__paint9_linear)"
    />
    <defs>
      <linearGradient
        id="MovieIcon_svg__paint0_linear"
        x1={0}
        y1={0}
        x2={48.5}
        y2={37}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.516} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint1_linear"
        x1={3}
        y1={2}
        x2={48.5}
        y2={35.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.516} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint2_linear"
        x1={2}
        y1={2.5}
        x2={48}
        y2={35.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.932} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint3_linear"
        x1={3.5}
        y1={2}
        x2={50.5}
        y2={34.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.755} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint4_linear"
        x1={3.5}
        y1={2.5}
        x2={49.5}
        y2={33.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.276} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint5_linear"
        x1={4.5}
        y1={3.5}
        x2={48.5}
        y2={33}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint6_linear"
        x1={5.5}
        y1={3.5}
        x2={48.5}
        y2={34}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.932} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint7_linear"
        x1={4.5}
        y1={2.5}
        x2={48.5}
        y2={33.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.755} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint8_linear"
        x1={4.5}
        y1={3.5}
        x2={48.5}
        y2={33.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0.276} stopColor="#5937BC" />
        <stop offset={0.861} stopColor="#4438AA" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
      <linearGradient
        id="MovieIcon_svg__paint9_linear"
        x1={5.5}
        y1={4}
        x2={48.5}
        y2={34}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#973FA5" />
        <stop offset={0} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgMovieIcon
